/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Edit_DescriptionInputs */

const en_admin_posts_edit_description = /** @type {(inputs: Admin_Posts_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update post details`)
};

/**
* | output |
* | --- |
* | "Update post details" |
*
* @param {Admin_Posts_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_edit_description = /** @type {((inputs?: Admin_Posts_Edit_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Edit_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_edit_description(inputs)
});
export { admin_posts_edit_description as "admin.posts.edit_description" }